import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'

export const SuccessPage = () => {
    const location = useLocation();

    const {
        checkInDate,
        checkOutDate,
        grandTotal,
        propertyName, address
    } = location.state || {};


    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
        });
    };

    return (
        <>
            <div className="card">
                <div className="header">
                    <div className="icon-wrap">
                        <i className="fas fa-check" />
                    </div>
                    <h1>Booking Confirmed</h1>
                    <p className="subtitle">Confirmation email has been sent to your inbox.</p>
                    <div className="badge">
                        <span className="dot" /> CONFIRMED
                    </div>
                </div>
                <div className="details">
                    <div className="row">
                        <div className='col-md-3'>
                            <span className="lbl">Hotel Name</span>
                        </div>
                        <div className='col-md-9'>
                            <div className="val">{propertyName}</div>
                        </div>
                    </div>

                    <div className="row">
                        <div className='col-md-3'>
                            <span className="lbl">Date &amp; Time</span>
                        </div>
                        <div className='col-md-9'>
                            <div className="val">
                                {formatDate(checkInDate)}
                                <div className="val-sub">11:00 AM – 12:00 PM</div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className='col-md-3'>
                            <span className="lbl">Location</span>
                        </div>
                        <div className='col-md-9'>
                            <div className="val">{address}</div>
                        </div>
                    </div>


                    {/* <div className="total">
                        <span className="total-label">Total Amount</span>
                        <span className="total-amount"> ₹{Number(grandTotal || 0).toLocaleString("en-IN")}</span>
                    </div> */}
                </div>
                <div className="btns">
                    <NavLink to="/" className="btn btn-primary ">
                        <i className="fas fa-home" /> BACK TO HOME
                    </NavLink>
                </div>
            </div>
            <style>{`

                body {
        font-family: 'Inter', sans-serif;
        background: #f4f6fb;
        min-height: 100vh;
        align-items: center;
        justify-content: center;
        padding: 16px;
        color: #111827;
    }
    .card {
        background: #fff;
        border-radius: 14px;
        border-top: 5px solid #10b981;
        box-shadow: 0 2px 16px rgba(0,0,0,0.07);
        max-width: 480px;
        width: 100%;
        padding: 1.5rem 1.25rem 1.25rem;
        margin: 0 auto;
    }

    .header { text-align: center; }

    .icon-wrap {
        width: 54px;
        height: 54px;
        border-radius: 50%;
        background: #d1fae5;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 0.75rem;
    }

    .icon-wrap i { font-size: 28px; color: #10b981; }

    h1 { font-size: 20px; font-weight: 600; margin-bottom: 4px; }

    .subtitle { font-size: 13px; color: #6b7280; margin-bottom: 10px; }

    .badge {
        background: #d1fae5;
        color: #065f46;
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.05em;
        padding: 3px 10px;
        border-radius: 999px;
        display: inline-flex;
        align-items: center;
        gap: 5px;
    }

    .dot { width: 6px; height: 6px; border-radius: 50%; background: #10b981; }

    .details {
        background: #f3f4f6;
        border-radius: 10px;
        padding: 0.75rem 1rem;
        margin-top: 1rem;
    }

    .row {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 7px 0;
        border-bottom: 1px solid #e5e7eb;
        font-size: 13px;
    }

    .row:last-of-type { border-bottom: none; }

    .lbl { color: #6b7280; }

    .val { font-weight: 600; text-align: right; }

    .val-sub { font-size: 12px; font-weight: 400; color: #6b7280; margin-top: 2px; }

    .total {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 0.75rem;
        padding-top: 0.75rem;
    }

    .total-label { font-size: 15px; font-weight: 600; }

    .total-amount { font-size: 22px; font-weight: 700; color: #10b981; }

    .btns {
        margin-top: 0.875rem;
    }

    .btn {
        height: 40px;
        border-radius: 8px;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0.03em;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        cursor: pointer;
        border: none;
        transition: opacity 0.15s;
    }

    .btn:hover { opacity: 0.88; }

    .btn-outline {
        background: transparent;
        border: 1px solid #d1d5db;
        color: #111827;
    }

    .btn-primary {
        width: 100%;
        background: #10b981;
        color: #fff;
    }

    .btn-primary:hover {
        background: #0d8d62;
        color: #fff;
    }
    `}</style>
        </>
    )
}
